import { Modals } from "../components/Modals";
import { Table } from "../components/table-pagination-sorting/components/Table";
import { useDoneFetchActions } from "../hooks/useDoneFetchActions";
import { useAppDispatch } from "../store/store";
import { useState, useRef, useEffect, useCallback } from "react";
import { PaginatingAndSortingProps } from "../components/table-pagination-sorting/interfaces/interfaces";
import {
  initialTinas,
  propsTinas,
  tablePaginationRs,
} from "../utils/formsInitialsStates";
import {
  getTina,
  getTinas,
  savetTina,
} from "../services/tinaServices";
import { showMessage } from "../reducers/msgReducer";
import { TinaForm } from "../components/forms-modals/TinaForm";

export const Tinas = () => {
    const doneFetchActions = useDoneFetchActions();
  const dispatch = useAppDispatch();

  const [data, setData] = useState({ count: 0 } as {
    count: number;
    rows: Array<{ [key: string]: any }>;
  });

  const [datosTinas, setDatosTinas] = useState(
    {} as { on: string; data: propsTinas | undefined }
  );

  const tinaFormRef = useRef<{
    handleClick: () => propsTinas;
    resetForm: () => void;
  }>();

  const handelPagination = useCallback(
    (pagination: PaginatingAndSortingProps) => {
      function searchDataTina(tipe: string, id: number) {
        doneFetchActions(getTina(id)).then((resp: propsTinas) => {
          setDatosTinas({ on: tipe, data: resp });
        });
      }
      doneFetchActions(getTinas(pagination)).then(
        (data: tablePaginationRs) => {
          
          data.rows = data.rows?.sort((a, b) => (b.estado === true ? 1 : -1)).map((ob) => ({
            ...ob,
            estado:  ob.estado ? (
              <span className="icon-unlocked" style={{ color: '#007bff', fontSize: '1rem' }}></span>
            ) : (
              <span className="icon-lock" style={{ color: '#dc3545', fontSize: '1rem' }}></span>
            ),
            actions: (
              <>
                <button
                  className="btn"
                  onClick={() => searchDataTina("edit", ob.id)}
                >
                  <span className="icon-pencil" style={{ fontSize: '18px' }}></span>
                </button>
              </>
            ),
          }));
          setData((ant) => ({ ...ant, ...data }));
        }
      );
    },
    [doneFetchActions]
  );

  const onSaveModal = () => {
    const tinaValues = tinaFormRef.current?.handleClick();
    if (tinaValues) {
      doneFetchActions(savetTina(tinaValues)).then((resp) => {
        dispatch(
          showMessage({
            isShow: true,
            title: "Tina registrada con éxito",
            type: "success",
          })
        );
        handelPagination({} as PaginatingAndSortingProps);
        setDatosTinas({ on: "", data: initialTinas });
        tinaFormRef.current?.resetForm();
      });
    }
  };
  useEffect(() => {
    handelPagination({} as PaginatingAndSortingProps);
  }, [handelPagination]);

  const onCloseModal = () => {
    tinaFormRef.current?.resetForm();
    setDatosTinas({ ...datosTinas, on: "" });
  };

  const titles = [
    { title: "Tinas", sort: "nombre_tina" },
    { title: "Descripción", sort: "descripcion" },
    { title: "Capacidad", sort: "capacidad" },
    { title: "Estado", name: "estado" },
    { title: "Acciones", name: "actions" },
   
  ];
  
    return (
    <div>
    <div className="d-flex justify-content-center pt-4">
      <h4 className="align-self-end">Gestión de Tinas </h4>
    </div>
    <div className="d-flex justify-content-end pb-4">
      <div className="align-self-end">
        <button
          onClick={() => {
            setDatosTinas({ on: "add", data: undefined });
          }}
          type="button"
          className="btn btn-primary btn-rounded mb-4"
        >
          Crear Tina
        </button>
      </div>
    </div>
    <div></div>
    <Table
      dataTable={{ ...data, titles, limit: 100 }}
      onChange={handelPagination}
    />
    <Modals
      title="Crear nueva Tina"
      onSave={onSaveModal}
      onClose={onCloseModal}
      show={!!datosTinas.on}
    >
      <TinaForm
        ref={tinaFormRef}
        data={datosTinas.data}
        on={datosTinas.on}
      />
    </Modals>
    
  </div>
);
}